import { CSSTransition } from "react-transition-group"
import { ReactFragment } from "react"

import { Img } from "ui-kit/components-branded/index"

export function InCallBanner(props: {
    children?: ReactFragment
    visible?: boolean
    onVisibilityChange?: (visible: boolean) => void
}) {
    return (
        <CSSTransition
            classNames="fade-1s"
            timeout={1000}
            in={props.visible}
            unmountOnExit
            mountOnEnter
        >
            <div className="is-flex in-call-banner__wrapper">
                <div className="is-flex-grow-1 in-call-banner__text">{props.children}</div>
                <div className="is-flex is-justify-content-center is-align-items-center">
                    <Img
                        src="close-small.png"
                        className="in-call-banner__close-icon"
                        onClick={() => props.onVisibilityChange?.(false)}
                    />
                </div>
            </div>
        </CSSTransition>
    )
}
